type OmitTypenameDeep<T> = T extends (infer U)[]
  ? OmitTypenameDeep<U>[]
  : T extends object
    ? { [K in Exclude<keyof T, '__typename'>]: OmitTypenameDeep<T[K]> }
    : T;

/**
 * Recursively strip Apollo's `__typename` field from an object or array of objects,
 * so the result can be fed back into GraphQL mutation inputs.
 */
export function omitTypename<T>(value: T): OmitTypenameDeep<T> {
  if (value === null || typeof value !== 'object') {
    return value as OmitTypenameDeep<T>;
  }

  if (Array.isArray(value)) {
    return value.map(omitTypename) as OmitTypenameDeep<T>;
  }

  return Object.entries(value).reduce<Record<string, unknown>>((acc, [key, val]) => {
    if (key !== '__typename') {
      acc[key] = omitTypename(val) as unknown;
    }
    return acc;
  }, {}) as OmitTypenameDeep<T>;
}
